import { useCallback, useState, useMemo } from 'react';
import { useClickOutSide } from '../../../utils';
import { DropdownInputOptionsTypeguards } from '../../drop-down-inputs';


const useClose = (isActive, setIsDropdownOpen, setInputString) => {
  const closeDropdown = useCallback(() => {
    setIsDropdownOpen(false);
    setInputString('');
  }, []);
  const [innerSideRef] = useClickOutSide(closeDropdown, isActive);
  return [innerSideRef, closeDropdown];
};

export const getValue = (element) => {
  return DropdownInputOptionsTypeguards.isBaseOption(element)
    ? element.value
    : element;
}

export const inputUtils = (
  closeAfterClick,
  onClick,
  elements,
  getValueToFilter = getValue,
) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [inputString, setInputString] = useState('');

  const [innerSideRef, onClose] = useClose(
    isDropdownOpen,
    setIsDropdownOpen,
    setInputString
  );

  const onOpenDropdown = useCallback(() => {
    setIsDropdownOpen(true);
  }, []);

  const onClickDropDownTextItem = useCallback(
    (_, index) => {
      onClick(index);
      if (closeAfterClick) {
        onClose();
      }
    },
    [closeAfterClick, onClick]
  );

  const onClickArrowContainer = useCallback(
    (e) => {
      if (isDropdownOpen) {
        e.stopPropagation();
        onClose();
      }
    },
    [isDropdownOpen]
  );

  const onChangeValue = useCallback((e) => setInputString(e.target.value), []);
  const searchQuery = inputString.toLowerCase();

  const filteredElements = useMemo(() => elements.filter(
    (el) => getValueToFilter(el).toString().toLowerCase().includes(searchQuery),
  ), [elements, inputString, getValueToFilter]);


  return {
    setInputString,
    inputString,
    isDropdownOpen,
    onOpenDropdown,
    innerSideRef,
    onChangeValue,
    onClickArrowContainer,
    onClickDropDownTextItem,
    filteredElements,
  };
};
